// Stockholders Mutations

export const updateStockholdersList = (state, payload) => {
  state.stockholdersList = payload
}

export const setStockholderInfo = (state, payload) => {
  state.stockholderInfo = payload
}
